import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { measurementUnitRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.STORE];

const measurementUnitRouteMetadata: IRouteMetadataObj<
  typeof measurementUnitRoutesObj
> = {
  list: {
    title: "basicInfo.index.title",
    description: "empty",
    lazy: () => import("@pages/basicInfo/measurementUnit/table/page"),
    mode: "index",
    type: "main",
    icon: "Information2Line",
    breadcrumbs: [],
    permission,
  },
  create: {
    title: "basicInfo.measurementUnitManagement.create.title",
    description: "empty",
    lazy: () => import("@/pages/basicInfo/measurementUnit/form/page"),
    mode: "create",
    type: "inner",
    icon: "AddLine",
    breadcrumbs: [],
    permission,
  },
  edit: {
    title: "basicInfo.measurementUnitManagement.edit.title",
    description: "empty",
    lazy: () => import("@/pages/basicInfo/measurementUnit/form/page"),
    mode: "edit",
    type: "inner",
    icon: "EditLine",
    breadcrumbs: [],
    permission,
  },
};

export const measurementUnitRoutes = createRoute<
  typeof measurementUnitRoutesObj
>(measurementUnitRoutesObj, measurementUnitRouteMetadata);
